import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { TasksDrawer } from './TasksDrawer';
import { setActiveNamespace } from './tasksStore';
export const TasksDrawerRoot = ()=>{
    const userId = useStore(selectors.user.id);
    const businessId = useStore(selectors.user.businessId);
    useEffect(()=>{
        setActiveNamespace(userId, businessId);
    }, [
        userId,
        businessId
    ]);
    return /*#__PURE__*/ _jsx(TasksDrawer, {});
};
